import { Header              } from "../../main_components/header.js";
import { Loading             } from "../../main_components/loading.js";
import { ViewProjectBody     } from "./view_project_body.js";
import { useState, useEffect } from "react";
export const ViewProject = ( props ) => {
    const { loadingDuration } = props;
    const [ isLoaded, setIsLoaded ] = useState(false);
    const [ toggle,   setToggle   ] = useState(true);
    useEffect(() => {
        window.onload = _=> setIsLoaded(true);
        setTimeout(_=> {
            setIsLoaded(true);
            setTimeout(_=>{ setToggle(false) }, 500);
            }, loadingDuration);
    }, []);
    return (
        <>
            { toggle && <Loading page={ "View Project" } isLoaded={ isLoaded }/> }
            <Header link={ "Projects > View_Project" }/>
            <ViewProjectBody />
        </>
    );
};